import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations } from './translations';
import { translationsExtra } from './translations_extra';
import { translationsAbout } from './translations_about';

const deepMerge = (base, extra) => {
  const out = { ...base };
  for (const k in extra) {
    out[k] = extra[k] && typeof extra[k] === 'object' && !Array.isArray(extra[k]) && base[k]
      ? deepMerge(base[k], extra[k])
      : extra[k];
  }
  return out;
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('g28-lang') || 'it');

  useEffect(() => {
    localStorage.setItem('g28-lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = deepMerge(deepMerge(translations[lang] || translations.it, translationsExtra[lang] || {}), translationsAbout[lang] || {});

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
